import { render, staticRenderFns } from "./stockavailable.vue?vue&type=template&id=d5e35d48&"
import script from "./stockavailable.vue?vue&type=script&lang=ts&"
export * from "./stockavailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports